import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
// import { BrowseFilefolderDragdropContentComponent, UploadContent, UploadEvent } from 'src/app/shared/components/browse-filefolder-dragdrop-content/browse-filefolder-dragdrop-content.component';
import { DeviceStateRegistryService } from 'app/modules/remote-control/services/device-state-registry.service';
import { FileManagerService, UploadContent, UploadEvent } from 'xsmodules/remote-control/services/file-manager.service';
import { RcContext } from 'app/modules/remote-control-ng/context/rcContext';

@Component({
  selector: 'app-file-manager-upload-content-dialog',
  templateUrl: './file-manager-upload-content-dialog.component.html',
  styleUrls: ['./file-manager-upload-content-dialog.component.scss'],
})
export class FileManagerUploadContentDialogComponent implements OnInit, OnDestroy {
  // @ViewChild(BrowseFilefolderDragdropContentComponent, { static: false}) browseFilefolderDragdropContentComponent: BrowseFilefolderDragdropContentComponent;

  private sessionEndedSubscription: Subscription;
  private listOfUploadContent: UploadContent[];
  private form: FormGroup;
  private uploadPathOnDevice: string;
  private deviceKind: string;
  private errorMessage: string;

  constructor(
    private fileManagerService: FileManagerService,
    private dialogRef: MatDialogRef<FileManagerUploadContentDialogComponent>,
    private fb: FormBuilder,
    private deviceStateRegistry: DeviceStateRegistryService
  ) {}

  ngOnInit() {
    const deviceInfo = this.deviceStateRegistry.getState(RcContext.instance.sotiAssistDeviceId);
    this.deviceKind = deviceInfo.device.kind;
    const fileManagerState = this.fileManagerService.getState(RcContext.instance.sotiAssistDeviceId);

    this.uploadPathOnDevice = fileManagerState.fileTree.viewRootNode.data.fullPath;
    if (this.deviceKind.startsWith('Windows')) {
      this.uploadPathOnDevice = fileManagerState.fileTree.viewRootNode.data.fullPath.split('/').join('\\');
      if (!this.uploadPathOnDevice.endsWith('\\')) {
        this.uploadPathOnDevice += '\\';
      }
    } else if (!this.uploadPathOnDevice.endsWith('/')) {
      this.uploadPathOnDevice += '/';
    }

    this.buildForm();
    this.sessionEndedSubscription = this.fileManagerService.sessionEnded.subscribe(() => {
      this.cancel();
    });
  }

  ngOnDestroy() {
    if (this.sessionEndedSubscription) {
      this.sessionEndedSubscription.unsubscribe();
    }
  }

  // Closes the modal dialog without saving values
  public cancel() {
    this.dialogRef.close();
  }

  public uploadContent(event: UploadEvent): void {
    this.listOfUploadContent = [];
    if (event && event.content && event.content.length > 0 && event.content[0].content != null) {
      this.listOfUploadContent = event.content;
    }
  }

  // called when upload button is clicked.
  public upload() {
    if (this.overWriteFileOption) {
      this.listOfUploadContent.forEach(x => (x.overwrite = true));
    }
    this.fileManagerService.uploadContent(this.listOfUploadContent, this.uploadPathOnDevice);
    this.dialogRef.close();
  }

  public get isAnyFiletoUpload(): boolean {
    return this.listOfUploadContent && this.listOfUploadContent.length > 0;
  }

  public get overWriteFileOption(): boolean {
    return this.overWriteFile.value;
  }

  public toggleOverwriteFiles = (control: AbstractControl) => {
    if (control) {
      control.patchValue(!control.value);
    }
  };

  public setErrorMessageOfBrowseFileFolderDropContentComponent(errorMessage: string) {
    this.errorMessage = errorMessage;
  }

  private buildForm() {
    this.form = this.fb.group({
      uploadPath: new FormControl(this.uploadPathOnDevice),
      overWriteFile: false,
    });
  }

  get uploadPath(): AbstractControl {
    return this.form.get('uploadPath');
  }
  get overWriteFile(): AbstractControl {
    return this.form.get('overWriteFile');
  }
}
